import React from 'react';

import { FormattedMessage } from 'react-intl';

import Lozenge from '@atlaskit/lozenge';
import { token } from '@atlaskit/tokens';

import { messages } from './pull-request-activity-events.i18n';

type Props = {
  draft?: boolean;
};

export const PullRequestDraftEntry = ({ draft }: Props): JSX.Element => {
  const DraftLozenge = (
    <Lozenge isBold appearance={draft ? 'default' : 'inprogress'}>
      {draft ? (
        <FormattedMessage {...messages.draftEventLozenge} />
      ) : (
        <FormattedMessage {...messages.readyForReviewEventLozenge} />
      )}
    </Lozenge>
  );

  return (
    <>
      <span style={{ marginRight: token('space.050', '4px') }}>
        <FormattedMessage {...messages.draftContextMessage} />
      </span>
      {DraftLozenge}
    </>
  );
};
